module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exitfullScreen":"Exit Full Screen","fullScreen":"Full Screen"},"zh":{"exitfullScreen":"退出全屏","fullScreen":"全屏"}}')
  delete Component.options._Ctor
}
